import { FC } from "react";

import "./InformPanel.scss";
import { MigratedProductsDetails } from "../MigratedProducts/model";

const MigratedInformPanel: FC<MigratedProductsDetails> = ({
    cancelledLicensesCount,
    expiredLicensesCount,
    migratedLicensesCount,
    totalLicensesCount,
}) => {
    return (
        <div className="inform_panel__row">
            <div className="row__item">
                <div className="row__label">All Licenses:</div>
                <div className="row__data">{totalLicensesCount}</div>
            </div>

            <div className="row__item">
                <div className="row__label">Sold Licenses:</div>
                <div className="row__data">{expiredLicensesCount}</div>
            </div>

            <div className="row__item color_blue">
                <div className="row__label">Cancelled Licenses:</div>
                <div className="row__data">{cancelledLicensesCount}</div>
            </div>

            <div className="row__item">
                <div className="row__label">Migrated Licenses:</div>
                <div className="row__data">{migratedLicensesCount}</div>
            </div>
        </div>
    );
};

export default MigratedInformPanel;
